import { inject, observer } from 'mobx-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import useComponentDidMount from 'modules/core/hooks/useComponentDidMount';
import { DataTablePage } from 'modules/core/containers';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { QuickSearch } from 'modules/core/components/search';
import { unixToDateTimeString, dateTimeStringToUnix } from 'modules/core/utils/date';
import FormCheck from 'react-bootstrap/FormCheck';
import {
  vehicleActions,
  VehicleStore,
} from '../store/vehicleStore';
import * as URL from '../../../lib/router/url';

export interface VehicleOwnersProps {
  vehicleId: string,
  vehicleStore : VehicleStore,
}

const VehicleOwners = inject('vehicleStore')(observer((props: VehicleOwnersProps) => {
  const {
    vehicleId,
    vehicleStore,
  } = props;
  const {
    vehicleOwners,
    vehicleOwnersLoading,
    vehicleOwnersShowDeletedClients,
    vehicleOwnersShowDeletedRelations,
  } = vehicleStore;

  const [searchValue, setSearchValue] = useState<string>('');

  const columns = [
    {
      title: 'Телефон',
      name: 'phoneNumber',
      getCellValue: (row) => (
        <Link to={ `${ URL.URL_CLIENT_VIEW }/${ row.id }` }>
          { row.phoneNumber }
        </Link>
      ),
    },
    { name: 'name', title: 'ФИО', width: 170 },
    { name: 'statusRefValueName', title: 'Статус', width: 200 },
    {
      title: 'Партнёр',
      name: 'partnerName',
      getCellValue: (row) => (
        <Link to={ `${ URL.URL_PARTNERS_VIEW_ONE }/${ row.partnerId }` }>
          { row.partnerName }
        </Link>
      ),
    },
    {
      title: 'Дата блокировки клиента',
      name: 'deletedDate',
      getCellValue: (row, cell) => (row[cell] ? unixToDateTimeString(row[cell], 'DD.MM.YYYY HH:mm') : ''),
      sortValueConverter: (value) => (value ? dateTimeStringToUnix(value) : ''),
    },
    {
      title: 'Дата отцепки авто',
      name: 'relationDeletedDate',
      getCellValue: (row, cell) => (row[cell] ? unixToDateTimeString(row[cell], 'DD.MM.YYYY HH:mm') : ''),
      sortValueConverter: (value) => (value ? dateTimeStringToUnix(value) : ''),
    },
  ];

  const loadData = async (anyway = false) => {
    if (vehicleId && ((anyway) || (vehicleStore.vehicleOwnersByVehicleId !== vehicleId))) {
      await vehicleActions.getVehicleOwners(vehicleId);
    }
  };

  const handleChangeQuickSearch = (event: { target: { value: string } }) => {
    const value = (event.target as HTMLInputElement).value;
    setSearchValue((value?.length > 0) ? value : '');
  };

  const handleSubmitQuickSearch = (value: string) => {
    handleChangeQuickSearch({ target: { value } });
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <DataTablePage
      header='Владельцы автомобиля'
      columns={ columns }
      data={ vehicleOwners }
      dataLength={ vehicleOwners.length }
      onDataRequest={ loadData }
      loading={ vehicleOwnersLoading }
    >
      { ({ components }) => (
        <>
          <Row>
            <Col md={ 4 }>
              <components.PageHeader />
            </Col>
            <Col md={ 5 }>
              <Row className='justify-content-end'>
                <FormCheck
                  name='showDeleted'
                  label='Заблокированные клиенты   '
                  onChange={ () => {
                    vehicleActions.setVehicleOwnersShowDeletedClients();
                    loadData(true);
                  } }
                  checked={ vehicleOwnersShowDeletedClients }
                  className='page-buttons float-right align-items-start pt-2'
                />
                <FormCheck
                  name='showDeleted'
                  label='Отцепленные авто   '
                  onChange={ () => {
                    vehicleActions.setVehicleOwnersShowDeletedRelations();
                    loadData(true);
                  } }
                  checked={ vehicleOwnersShowDeletedRelations }
                  className='page-buttons float-right align-items-start pt-2'
                />
              </Row>
            </Col>
            <Col md={ 3 }>
              <QuickSearch
                name='searchText'
                value={ searchValue }
                placeholder='Быстрый поиск'
                disabled={ vehicleOwnersLoading }
                onClear={ handleSubmitQuickSearch }
                onChange={ handleChangeQuickSearch }
                onSubmit={ handleSubmitQuickSearch }
              />
            </Col>
          </Row>
          <Row>
            <Col md={ 12 }>
              <components.DataTable
                searchValue={ searchValue }
                localPaging
                localSorting
                hideToolbar
              />
            </Col>
          </Row>
        </>
      ) }
    </DataTablePage>
  );
}));

export { VehicleOwners };
